// Lightweight in-app visit tracker — sends one pageview per path change
import { api } from "./api";

const VID_KEY = "vedaheal_visitor_id";
let lastSent = null;
let lastTs = 0;

function getVisitorId() {
    let vid = localStorage.getItem(VID_KEY);
    if (!vid) {
        // 32-char hex — no crypto dep needed
        vid = `v_${Date.now().toString(36)}${Math.random().toString(36).slice(2, 14)}`;
        localStorage.setItem(VID_KEY, vid);
    }
    return vid;
}

export async function trackPageview(path) {
    const now = Date.now();
    // Debounce identical consecutive pageviews within 1s (StrictMode / rerenders)
    if (path === lastSent && now - lastTs < 1000) return;
    lastSent = path;
    lastTs = now;
    try {
        await api.post("/track/visit", {
            visitor_id: getVisitorId(),
            path,
        });
    } catch {
        // Best-effort — never let analytics break the app
    }
}
